import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var Breakpoint = /*#__PURE__*/function (Breakpoint) {
  Breakpoint["SMALL"] = "small";
  Breakpoint["LARGE"] = "large";
  return Breakpoint;
}({});
export var responsiveSettings = _defineProperty(_defineProperty({}, Breakpoint.SMALL, {
  fontSize: 11,
  lineHeight: 14,
  titleBox: {
    verticalPadding: 4,
    horizontalPadding: 8
  }
}), Breakpoint.LARGE, {
  fontSize: 14,
  lineHeight: 22,
  titleBox: {
    verticalPadding: 8,
    horizontalPadding: 12
  }
});
export var getTitleBoxHeight = function getTitleBoxHeight(breakpoint) {
  return (responsiveSettings[breakpoint].lineHeight + responsiveSettings[breakpoint].titleBox.verticalPadding) * 2;
};